import React from 'react'

const FormRadio = ({ name, size, status, label, image, disabled, value, onClick, checked }) => {
  return (
    <label
      className={
        `formradio` +
        (size ? ` formradio--${size}` : ' formradio--md') +
        (status ? ` formradio--${status}` : '') +
        (image ? ' formradio--with-image' : '')
      }
    >
      <input
        onChange={onClick}
        checked={checked}
        name={name}
        value={value}
        className="formradio__radio"
        type="radio"
        disabled={disabled}
      />
      <span className="formradio__styledradio"></span>
      {image && <span className="formradio__image">{image}</span>}
      <span className="formradio__label">{label}</span>
    </label>
  )
}

export default FormRadio
